
// import React from 'react';
import { styled, Box } from '@mui/material';

/**
A styled Box component that creates a flexible space.
@component
*/
const Spacer = styled(Box)(() => ({
  flexGrow: 1,
}))

export default Spacer;
